/**
 * 워크스페이스 기능 키 · 사용자 유형(축) — 화면 판정의 유일한 어휘(specs/064 FR-011).
 *
 * 화면은 역할 이름이 아니라 세션의 `features`(서버 기능 허용 표의 결과)로 진입·메뉴·요소 노출을 판단한다.
 * 이름은 백엔드 `WorkspaceFeature`·`MemberAxis` enum 과 같다 — `api/contract.ts` 가 OpenAPI 와 대조한다.
 */

export const WORKSPACE_FEATURES = [
  'ANNOUNCEMENT_FINDER',
  'COMPANY_HOME',
  'TASKS',
  'CALENDAR',
  'MULTI_COMPANY',
  'MY_COMPANY',
  'COMPANY_JUDGEMENT',
  'ROADMAP',
  'PROGRAM_DETAIL',
  'CONSULTANT_ANNOUNCEMENT',
  'SUBSCRIPTION',
  'BILLING',
  'GUIDE',
  'CERTIFICATION',
] as const;

export type WorkspaceFeature = (typeof WORKSPACE_FEATURES)[number];

/** 워크스페이스 사용자 유형(축) — 경영지도사 / 기업·소상공인·예비창업자(specs/065). */
export const MEMBER_AXES = ['CONSULTANT', 'COMPANY'] as const;

export type MemberAxis = (typeof MEMBER_AXES)[number];

/** 회원 유형 표시 이름 — 가입 선택 카드·계정 메뉴가 같은 말을 쓴다. */
export const MEMBER_AXIS_LABELS: Record<MemberAxis, string> = {
  CONSULTANT: '경영지도사·컨설턴트',
  COMPANY: '기업·소상공인·예비창업자',
};

const FEATURE_SET: ReadonlySet<string> = new Set(WORKSPACE_FEATURES);
const AXIS_SET: ReadonlySet<string> = new Set(MEMBER_AXES);

/** 서버가 준 문자열 중 알려진 기능 키만 남긴다(모르는 키는 무시 — 서버가 앞서 배포돼도 안전). */
export function toWorkspaceFeatures(raw: readonly string[] | null | undefined): WorkspaceFeature[] {
  return (raw ?? []).filter((f): f is WorkspaceFeature => FEATURE_SET.has(f));
}

export function toMemberAxis(raw: string | null | undefined): MemberAxis | null {
  return raw && AXIS_SET.has(raw) ? (raw as MemberAxis) : null;
}
